import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ProfilerNavbar from '../profilerEditingPage/profilerNavBar'; // Use the candidate-facing navbar
import JobCard from '../jobsRecommendationPage/jobCard'; // Reuse your JobCard component
import { mockRecommendedJobs } from '../../../data/mockRecommendedJobs'; // Use the recommended jobs data
import { FiSearch } from 'react-icons/fi';

// A reusable component for the filter tabs
const FilterTab = ({ label, count, isActive, onClick }) => (
    <button
        onClick={onClick}
        className={`px-3 py-1.5 rounded-xl text-xs font-semibold transition-colors ${isActive
                ? 'mph-primary bg-white shadow-md'
                : 'text-gray-999'
            }`}
    >
        {label}
        <span className={`ml-2 text-xs p-1 rounded-full ${isActive ? 'mph-primary-bg text-white' : 'bg-white shadow-md '
            }`}>
            {count}
        </span>
    </button>
);

const OpportunitiesPage = () => {
    const [activeTab, setActiveTab] = useState('All');

    // Define the filter tabs
    const tabs = [
        { label: 'All', count: 50 },
        { label: 'Recommended jobs', count: 10 },
        { label: 'Applied', count: 8 },
        { label: 'Saved jobs', count: 2 },
    ];

    return (
        <div className="min-h-screen main-background">
            <ProfilerNavbar />
            <main className="mx-auto px-8 pb-8 pt-24">

                {/* --- Main Content Card --- */}
                <div className="">

                    {/* Header: Tabs and Search */}
                    <div className="flex justify-between items-center mb-3">
                        <div className="flex items-center gap-3">
                            {tabs.map(tab => (
                                <FilterTab
                                    key={tab.label}
                                    label={tab.label}
                                    count={tab.count}
                                    isActive={activeTab === tab.label}
                                    onClick={() => setActiveTab(tab.label)}
                                />
                            ))}
                        </div>
                        <div className="relative w-1/2">
                            <input
                                type="text"
                                placeholder="Search for jobs"
                                className="w-full rounded-full py-2 pl-5 pr-8 text-xs shadow-md focus:outline-none placeholder:text-gray-999"
                            />
                            <FiSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 mph-primary" />
                        </div>
                    </div>

                    {/* Job List Grid */}
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mt-2">
                        {mockRecommendedJobs.map(job => (
                            <JobCard key={job.id} job={job} />
                        ))}
                    </div>

                </div>
            </main>
        </div>
    );
};

export default OpportunitiesPage;